module.exports = __webpack_public_path__ + "static/media/The-Chinese-University-of-Hong-Kong-CUHK.19a42d4e.jpg";